export default __webpack_public_path__ + "static/media/T40.0d6c6d67.JPG";